export default {
  API_URL: 'https://tq-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://tqsandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
